<!--  -->
<template>
  <div class="twin">
    <div class="tips">我们能为您提供什么</div>
    <div>构建全民共享的智能化服务平台</div>
    <div class="twinMain">
      <div v-for="(item, index) in serviceList" :key="index" class="every">
        <div class="p20">
          <div class="everyTop">
            <img :src="item.img" alt="" />
            <div class="everyName">{{ item.name }}</div>
          </div>
          <div>
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      serviceList: [
        {
          name: "立即结算",
          img: require("@/assets/Immediate-settlement.png"),
          text: "平台提供快速结算服务，资金到账快速迅捷",
        },
        {
          name: "资金安全",
          img: require("@/assets/fund-security.png"),
          text: "多重保障措施，确保资金安全无忧",
        },
        {
          name: "风险保障",
          img: require("@/assets/risk-guarantee.png"),
          text: "确保作业者持证上岗，保险实时生效，加强作业过程监管全方位防控",
        },
        {
          name: "解决方案",
          img: require("@/assets/solution.png"),
          text: "从招聘到管理，提供全方位定制化服务支持",
        },
        {
          name: "精准匹配",
          img: require("@/assets/Precise-matching.png"),
          text: "高效匹配发包方与接单者，快速匹配专业技能人才，促进业务合作",
        },
        {
          name: "在线培训",
          img: require("@/assets/online-training.png"),
          text: "提供丰富的在线课程，模拟练习，助力技能水平提升",
        },
        {
          name: "数据分析",
          img: require("@/assets/data.png"),
          text: "精准数据分析，助力决策优化，可视化数据展示",
        },
        {
          name: "行业资讯",
          img: require("@/assets/industry-information.png"),
          text: "实时更新行业动态，把握市场先机，促进信息畅通",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.twin {
  text-align: center;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #141414;
  background: #f4f7fc;
  line-height: 36px;
  padding: 80px 360px;
  .tips {
    font-weight: 500;
    font-size: 28px;
    color: #141414;
    margin-bottom: 5px;
  }
  .twinMain {
    margin-top: 50px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .every {
      width: 24%;
      background: #ffffff;
      border-radius: 4px 4px 4px 4px;
      margin-bottom: 20px;
      .everyName {
        font-weight: 500;
        font-size: 22px;
        color: #141414;
      }
      .p20 {
        padding: 68px 32px;
        text-align: initial;
      }

      .everyTop {
        display: flex;
        align-items: center;
        padding-bottom: 16px;
        border-bottom: 1px solid #e4e7ed;
        margin-bottom: 14px;
      }
      img {
        width: 50px;
        height: 50px;
        margin-right: 10px;
      }
    }
  }
}

/* 在小屏幕上使用单列布局 */
@media (max-width: 768px) {
  .twin {
    padding: 80px 200px;
  }
}
</style>
